export const configuratorVisualizationKeys = {
    root: ['configurator-visualization'] as const,
    // Include showroomPath so an anonymous showroom fetch (public endpoint) never shares a cache entry
    // with the authenticated per-unit fetch for the same unit id.
    byUnit: (residentialUnitId: number, showroomPath?: string | null) =>
        ['configurator-visualization', residentialUnitId, showroomPath ?? null] as const,
};
